import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useMaskPII } from 'hooks/useMaskPII';
import {
  selectDetails,
  selectIsLoading as selectIsLoadingRetrieveQuote,
  selectErrors as selectRetriveQuoteErrors,
  setFormField
} from 'state/retrieve-quote/retrieve-quote-slice';
import {
  selectIsLoading as selectIsLoadingInititate,
  selectErrors as selectInititateErrors
} from 'state/initiate/initiate-slice';
import { selectors as meterPointValidationSelectors } from 'state/meterpoint-validation/meterpoint-validation-slice';

const getDefaultValue = (val) => val || '';

export const useRetrieveQuote = () => {
  const dispatch = useDispatch();
  const { quoteId: quoteIdParam } = useParams();

  const { postcode, email, quoteId } = useSelector(selectDetails, shallowEqual);
  const isLoadingInititate = useSelector(
    selectIsLoadingInititate,
    shallowEqual
  );
  const isLoadingRetrieveQuote = useSelector(
    selectIsLoadingRetrieveQuote,
    shallowEqual
  );
  const isLoadingMeterType = useSelector(
    meterPointValidationSelectors.selectIsLoading,
    shallowEqual
  );
  const isLoading =
    isLoadingInititate || isLoadingRetrieveQuote || isLoadingMeterType;
  const inititateErrors =
    useSelector(selectInititateErrors, shallowEqual) || [];
  const retrieveQuoteErrors =
    useSelector(selectRetriveQuoteErrors, shallowEqual) || [];
  const meterTypeErrors = useSelector(
    meterPointValidationSelectors.selectAPIErrors,
    shallowEqual
  );
  const apiErrors = [
    ...inititateErrors,
    ...retrieveQuoteErrors,
    ...meterTypeErrors
  ];
  const { mask } = useMaskPII();

  useEffect(() => {
    dispatch(setFormField({ name: 'quoteId', value: quoteIdParam }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    quoteId: getDefaultValue(quoteId),
    postcode: getDefaultValue(postcode),
    email: getDefaultValue(email),
    isLoading,
    apiErrors,
    mask
  };
};
